// 多选部门dlg组件

const branchDlgMul = {
  namespaced: true,

  state: {
    dlgShow: false,

    dlgType: '',

    branchIds: '',

    branchNames: '',

    projectId: '',

    isPage:false,
    isReturn:"",
    startingPoint:"",
    startingName:"",
  },

  getters: {
    dlgShow: state => state.dlgShow,

    dlgType: state => state.dlgType,

    branchIds: state => state.branchIds,

    branchNames: state => state.branchNames,

    projectId: state => state.projectId,

    isPage: state => state.isPage,
    isReturn: state => state.isReturn,
    startingPoint: state => state.startingPoint,
    startingName: state => state.startingName,
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_DLGTYPE: (state, val) => {
      state.dlgType = val
    },

    SET_BRANCHIDS: (state, val) => {
      state.branchIds = val
    },

    SET_BRANCHNAMES: (state, val) => {
      state.branchNames = val
    },

    SET_PROJECTID: (state, val) => {
      state.projectId = val
    },

    SET_ISPAGE: (state, val) => {
      state.isPage = val
    },
    SET_ISRETURN: (state, val) => {
      state.isReturn = val
    },
    SET_STARTINGPOINT: (state, val) => {
      state.startingPoint = val
    },
    SET_STARTINGNAME: (state, val) => {
      state.startingName = val
    },
  },

  actions: {

  }
}

export default branchDlgMul
